import { render, staticRenderFns } from "./UserEnrichment.vue?vue&type=template&id=c2da69c2&scoped=true&"
import script from "./UserEnrichment.vue?vue&type=script&lang=js&"
export * from "./UserEnrichment.vue?vue&type=script&lang=js&"
import style0 from "./UserEnrichment.vue?vue&type=style&index=0&id=c2da69c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2da69c2",
  null
  
)

export default component.exports